import { FC, useContext } from 'react'
import { Row } from 'antd'
import { FileOutlined } from '@ant-design/icons'

import { StatusTicketEnum, Ticket } from '@types'
import { TicketNotifContext, useHandleTicketModal } from '@contexts'

interface DeliveryNoteProps {
  ticket: Ticket
}

const DeliveryNote: FC<DeliveryNoteProps> = ({ ticket }) => {
  const { setTicketToEdit } = useHandleTicketModal()
  const ticketNotification = useContext(TicketNotifContext)

  const handleClick = () => {
    const { id } = ticket
    ticketNotification.setState(ticket.id)
    setTicketToEdit(id)
  }

  return (
    <Row align="middle">
      {ticket.deliveryNote ? (
        <div
          title={ticket.deliveryNote}
          style={{ color: '#008F39', width: '100%', whiteSpace: 'normal' }}
        >
          {ticket.deliveryNote.length > 15
            ? `${ticket.deliveryNote.slice(0, 15)}...`
            : ticket.deliveryNote}
        </div>
      ) : (
        <div style={{ color: '#B32428', width: '100%', whiteSpace: 'normal' }}>n/a</div>
      )}
      {ticket.countFile > 0 && ticket.status.name !== StatusTicketEnum.PENDING && (
        <FileOutlined
          style={{ marginLeft: 10, width: '100%', whiteSpace: 'normal' }}
          onClick={() => {
            handleClick()
          }}
        />
      )}
    </Row>
  )
}

export { DeliveryNote }
